import {
  AcceptedPaymentMethods,
  CountryCodeType,
  TechnicianContactRole,
  UnavailabilityReason,
  ZoneType,
  TechnicianDocumentType,
  TechnicianContractStatus,
} from '@depanneo/types'

export const OPERATIONAL_CONTACT_OPTIONS = [
  {
    value: 'true',
    label: 'Identique au gérant',
  },
  {
    value: 'false',
    label: 'Nouveau contact',
  },
]

export const CONTACT_FIELDS = [
  'firstName',
  'lastName',
  'email',
  'mobilePhone',
  'landlinePhone',
] as const

export const CONTACT_ROLE_LABELS: Record<TechnicianContactRole, string> = {
  [TechnicianContactRole.PRIMARY]: 'Gérant',
  [TechnicianContactRole.OPERATIONAL]: 'Opérationnel',
  [TechnicianContactRole.SECONDARY]: 'Employé',
  [TechnicianContactRole.EMERGENCY]: 'Urgence',
  [TechnicianContactRole.BILLING]: 'Facturation',
}

export const SECONDARY_CONTACT_ROLE_OPTIONS = [
  { value: TechnicianContactRole.SECONDARY, label: 'Employé' },
  { value: TechnicianContactRole.BILLING, label: 'Facturation' },
  { value: TechnicianContactRole.EMERGENCY, label: 'Urgence' },
  { value: TechnicianContactRole.OPERATIONAL, label: 'Opérationnel' },
  { value: TechnicianContactRole.PRIMARY, label: 'Principal' },
]

export const BILLING_ADDRESS_OPTIONS = [
  {
    value: 'true',
    label: "Identique à l'adresse légale de l'entreprise",
  },
  {
    value: 'false',
    label: 'Nouvelle adresse',
  },
]

export const BILLING_CONTACT_OPTIONS = [
  {
    value: 'true',
    label: 'Identique au gérant',
  },
  {
    value: 'false',
    label: 'Nouveau contact',
  },
]

export const PAYMENT_METHOD_OPTIONS = [
  { value: AcceptedPaymentMethods.DEBIT_CARD, label: 'Carte bancaire' },
  { value: AcceptedPaymentMethods.CASH, label: 'Espèces' },
  { value: AcceptedPaymentMethods.CHECK, label: 'Chèque' },
  { value: AcceptedPaymentMethods.WIRE_TRANSFER, label: 'Virement' },
]

export const unavailabilityReasonOptions = [
  { value: UnavailabilityReason.VACATION, label: 'Vacances' },
  { value: UnavailabilityReason.TRAINING, label: 'Formation' },
  { value: UnavailabilityReason.ILLNESS, label: 'Maladie' },
  { value: UnavailabilityReason.PERSONAL, label: 'Personnel' },
  { value: UnavailabilityReason.OTHER, label: 'Autre' },
]

export const zoneTypeOptions = [
  { value: ZoneType.POSTAL_CODE, label: 'Code postal' },
  { value: ZoneType.DEPARTMENT, label: 'Département' },
]

// dayOfWeek 0 = Sunday … 6 = Saturday, like the database (#3138); each entry
// sits at the position equal to its dayOfWeek (`workHours[${day.dayOfWeek}]`).
export const initialWorkHours = [
  { dayOfWeek: 0, timeStart: '08:00:00', timeEnd: '18:00:00', is247: false },
  { dayOfWeek: 1, timeStart: '08:00:00', timeEnd: '18:00:00', is247: false },
  { dayOfWeek: 2, timeStart: '08:00:00', timeEnd: '18:00:00', is247: false },
  { dayOfWeek: 3, timeStart: '08:00:00', timeEnd: '18:00:00', is247: false },
  { dayOfWeek: 4, timeStart: '08:00:00', timeEnd: '18:00:00', is247: false },
  { dayOfWeek: 5, timeStart: '08:00:00', timeEnd: '18:00:00', is247: false },
  { dayOfWeek: 6, timeStart: '08:00:00', timeEnd: '18:00:00', is247: false },
]

export const COUNTRY_LABELS: Record<CountryCodeType, string> = {
  FR: 'France',
  BE: 'Belgique',
  CH: 'Suisse',
  LU: 'Luxembourg',
} as const

// === STEP 5 ===
export const DOCUMENTS_ACCEPTED_TYPES = ['.pdf']
export const DOCUMENTS_MAX_SIZE_MB = 5

export const CONTRACT_STATUS_OPTIONS = [
  {
    value: TechnicianContractStatus.SENT,
    label: 'Envoyé',
  },
  {
    value: TechnicianContractStatus.SIGNED,
    label: 'Signé',
  },
]

export const REQUIRED_DOCUMENTS = [
  {
    key: 'identity',
    type: TechnicianDocumentType.IDENTITY,
    label: "Pièce d'identité (carte d'identité ou passeport)",
  },
  {
    key: 'urssaf',
    type: TechnicianDocumentType.URSSAF,
    label: "Attestation de vigilance ou d'entreprise (URSSAF ou SSI)",
  },
  {
    key: 'insee',
    type: TechnicianDocumentType.INSEE,
    label: "Justificatif d'immatriculation / répertoire INSEE",
  },
  {
    key: 'tax',
    type: TechnicianDocumentType.TAX,
    label: 'Attestation fiscale / CERFA 3666',
  },
  {
    key: 'insurance',
    type: TechnicianDocumentType.INSURANCE,
    label: "Attestation d'assurance RC Pro (RCP)",
  },
] as const

export const OPTIONAL_DOCUMENTS = [
  {
    key: 'foreign_employees',
    type: TechnicianDocumentType.FOREIGN_EMPLOYEES,
    label: 'Liste des salariés étrangers',
  },
  {
    key: 'honor_attestation',
    type: TechnicianDocumentType.HONOR_ATTESTATION,
    label: "Attestation sur l'honneur",
  },
] as const

export const DOCUMENT_KEY_TO_TYPE: Record<string, TechnicianDocumentType> = {
  contract: TechnicianDocumentType.CONTRACT,
  identity: TechnicianDocumentType.IDENTITY,
  urssaf: TechnicianDocumentType.URSSAF,
  insee: TechnicianDocumentType.INSEE,
  tax: TechnicianDocumentType.TAX,
  insurance: TechnicianDocumentType.INSURANCE,
  foreign_employees: TechnicianDocumentType.FOREIGN_EMPLOYEES,
  honor_attestation: TechnicianDocumentType.HONOR_ATTESTATION,
}
